import { createRoot } from 'react-dom/client';
import { scan } from 'react-scan';

import { LicenseManager } from 'ag-grid-enterprise';

import '@fortawesome/fontawesome-svg-core/styles.css';

import { isNotDefined } from '@enterprise/core';
import { registerIcons } from '@enterprise/ui';

import './styles/index.css';

import { AG_GRID_LICENSE_KEY } from '@/common/constants/config';
import { getEnvVar } from '@/utilities/get-env-var';

import App from './app/app';

const rootElement = document.getElementById('root');
const isLocal = getEnvVar('VITE_APP_ENVIRONMENT') === 'local';

if (isNotDefined(rootElement)) {
  throw new Error('Root element #root not found in document.');
}

scan({
  enabled: isLocal,
  showToolbar: isLocal,
});

const root = createRoot(rootElement);

registerIcons();

LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);

root.render(<App />);
